import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const timeSchema = surrealRecordSchema.extend({
  from: z.coerce.date(),
  to: z.coerce.date().optional(),
  hours: z.number(),
  project: z.string(),
  task: z.string(),
  description: z.string().optional(),
});
export const timesSchema = z.array(timeSchema);

export const timeCreateSchema = timeSchema.omit({ id: true, hours: true });
export const timeUpdateSchema = timeSchema
  .omit({ id: true, hours: true })
  .partial();

export type Time = z.infer<typeof timeSchema>;
export type TimeCreate = z.infer<typeof timeCreateSchema>;
export type TimeUpdate = z.infer<typeof timeUpdateSchema>;
